import { IntraSectionItem } from './IntraSectionItem';

class IntraSection {
  constructor(params) {
    this.order = params.order;
    this.icon = params.icon;
    this.title = params.title;
    this.items = params.items.sort((a, b) => (a.order < b.order ? -1 : 1))
      .map(item => new IntraSectionItem(item));
  }
}

export { IntraSection };



// WEBPACK FOOTER //
// ./src/models/IntraSection.js